export default {
  SWRegistrationForNewContent: null,
  refreshingApp: false,
  appTitle: 'SNABB',
  languages: [
    { code: 'en', title: 'English', flag: 'GB' },
    { code: 'et', title: 'Eesti', flag: 'EE' },
    { code: 'lv', title: 'Latviešu', flag: 'LV' },
    { code: 'lt', title: 'Lietuvių', flag: 'LT' }
    // { code: 'ru', title: 'русский', flag: 'RU' }
  ],
  selectedLanguage: { code: 'en', title: 'English', flag: 'GB' },
  snackbar: {
    show: false,
    type: null,
    message: null
  },
  error: null,
  loading: { type: null, state: false },
  searchString: '',
  sidebarDrawer: true,
  currentPageNumber: 1,
  availableApplications: [],
  appIcons: [],
  theme: 'light',
  vehicleNumberSearchString: '',
  quickActions: []
}
